const gql = require('graphql-tag');

const PAY_DAMAGE_CLAIM_QUERY = gql`
    query ShowPDCForm($createPayNowFormRequest: CreatePayNowFormRequest) {
        createPayNowForm(createPayNowFormRequest: $createPayNowFormRequest) {
            scheduledPaymentUuid
            claimStatus {
                paymentStatus
                last4
                amount {
                    amount
                    currencyCode
                    localizedAmount
                }
            }
            messageFromOwner
            paymentMethods {
                label
                sensitiveForm {
                    panUrl
                    cvnUrl
                }
                type
                supportedCardTypes
            }
            countries {
                label
                code
                stateLabel
                states {
                    code
                    label
                }
            }
            countrySettings {
                countryCode
                postalCodeRequired
                validation {
                    postalCode
                }
            }
            hapiForm {
                hapiSessionUuid
                hapiSensitiveFormUuid
            }
        }
    }
`;

export default PAY_DAMAGE_CLAIM_QUERY;
